import { render } from "./BusinessProfilePage.vue?vue&type=template&id=fe63d8fa&ts=true"
import script from "./BusinessProfilePage.ts?vue&type=script&lang=ts"
export * from "./BusinessProfilePage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__